import { createSelector } from '@reduxjs/toolkit';

import { IChatImageFile } from '../../repositories/chats/entities/file/ChatImageFile';
import { getFileSrc } from '../../utils/getFileSrc';
import { chatImagesSelector } from '../chatImagesSelector';
import { selectContentFullscreenSelectedImageUid } from '../contentFullscreen';
import { currentOpenChatIDSelector } from '../currentOpenChatIDSelector';

/**
 * Слайды галереи и индекс выбранного. Если выбранного фото ещё нет в загруженном списке,
 * оно подмешивается в конец, чтобы галерея открылась на нём и позволяла листать остальные.
 */
export const gallerySelector = createSelector(
  [chatImagesSelector, selectContentFullscreenSelectedImageUid, currentOpenChatIDSelector],
  (chatImages, selectedImageUid, chatId) => {
    const loadedFiles = chatImages?.files || [];
    const files: IChatImageFile[] =
      !selectedImageUid || loadedFiles.some(file => file.uid === selectedImageUid)
        ? loadedFiles
        : [...loadedFiles, { uid: selectedImageUid, name: '', userId: 0, created: 0 }];

    return {
      slides: files.map(file => ({ src: getFileSrc(file.uid, chatId), uid: file.uid })),
      slideIndex: files.findIndex(file => file.uid === selectedImageUid),
    };
  },
);
